import {convertToRaw} from 'draft-js';
import type {ContentState} from 'draft-js';
import {convertFromDraftJsToHtml} from '../../../../shared/components/rich-text-editor-draftjs-wrapper/DraftJsToHtmlConverter';
import {ticketingEntityTransform} from './ticketingEntityTransform';
import {sanitizeMessageHtml} from './sanitizeMessageHtml';

export function editorToHtml(contentState: ContentState): string {
	const raw = JSON.stringify(convertToRaw(contentState));
	const rawHtml = convertFromDraftJsToHtml(raw, ticketingEntityTransform);

	return sanitizeMessageHtml(rawHtml);
}
